import { defineStore } from 'pinia'
import { useApi } from '~/composables/useApi'

export const useVenueStore = defineStore('venue', {
  state: () => ({
    venue: {
      loading: false,
      data: {},
    },

    nearby: {
      data: {},
      loading: false,
    },
  }),

  actions: {
    async loadVenue (path) {
      this.venue.loading = true
      try {
        const resp = await useApi('venues/show', {
          query: {
            extended_info: true,
            path,
          },
        })
        this.venue.data = resp.response.venues[0] || {}
      } finally {
        this.venue.loading = false
      }
    },

    async loadNearby () {
      this.nearby.loading = true
      try {
        const resp = await useApi('nearby', {
          query: {
            show_photos: true,
            show_featured_extracts: true,
            venue_id: this.venue.data.id,
          },
        })
        this.nearby.data = resp.venues || []
      } finally {
        this.nearby.loading = false
      }
    },

    clearNearby () {
      this.nearby.data = []
    },
  },
})
